// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"AuqSID2JvoMVpqmUWYyI8 _2HS5pq_sG-4tAB_x0bbn6Z","layoutWrapperBackgroundLayer":"xVsokPWa9khYyhK_omjXs _1VVBEiJ0Yq6pgVYuxEH73x"};